<template>
  <div class="charts-page">

    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel
          class="chart-widget"
          :title="tituloPagina"
          :footerText="rodapePagina"
          :footerComplementar="rodapeComplementarPagina"
          :tooltipOptions="tooltipOptions"
          :noPadding="iframeOcuparPainelCompleto">
          <iframeBI :fonte='fonte.url' :width='width' :height='height' 
              :scrolling='scrolling' :frameborder='frameborder' :estiloContainer='estiloContainer'
              :estiloIframe='estiloIframe'> </iframeBI>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import _ from 'lodash'
import iframeBI from '@/components/iframe/implementacoes/iframeBI'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'dashboard-iframe-publico',
  components: {
    iframeBI,
    Sp360Panel,
  },
  props: ['chaveIframe'],
  data: () => ({
    fonte: {},
    fonteDados: "",
    dataDados: "",
    tituloPagina: "",
    rodapePagina: "",
    rodapeComplementarPagina: "",
    iframeOcuparPainelCompleto: false,
    width: undefined,
    height: undefined,
    scrolling: undefined,
    frameborder: undefined,
    estiloContainer: {},
    estiloIframe: {},
    tooltipOptions: null,
    iframeEmbeddingConfig: {}
  }),
  created () {
    this.buscarLinkBi()
  },
  methods: {
    buscarLinkBi () {
      this.$store.dispatch('iframeDashboard/buscarUrlIframe', { nome: this.chaveIframe })
        .then((retorno) => {
          this.fonte = retorno.data
          this.configurarDashboard()
        }).catch((error) => {
          console.error(error)
        })
    },
    configurarDashboard() {
      if(this.fonte.iframeEmbeddingConfig) {
        if(this.fonte.iframeEmbeddingConfig.width)
          this.width = this.fonte.iframeEmbeddingConfig.width
        if(this.fonte.iframeEmbeddingConfig.height)
          this.height = this.fonte.iframeEmbeddingConfig.height
        if(this.fonte.iframeEmbeddingConfig.scrolling)
          this.scrolling = this.fonte.iframeEmbeddingConfig.scrolling
        if(this.fonte.iframeEmbeddingConfig.frameborder)
          this.frameborder = this.fonte.iframeEmbeddingConfig.frameborder
        if(MetodosGlobais.isObject(this.fonte.iframeEmbeddingConfig.estiloContainer) && 
            Object.keys(this.fonte.iframeEmbeddingConfig.estiloContainer).length)
          this.estiloContainer = this.fonte.iframeEmbeddingConfig.estiloContainer
        if(MetodosGlobais.isObject(this.fonte.iframeEmbeddingConfig.estiloIframe) && 
            Object.keys(this.fonte.iframeEmbeddingConfig.estiloIframe).length)
          this.estiloIframe = this.fonte.iframeEmbeddingConfig.estiloIframe

        if(this.fonte.iframeEmbeddingConfig.iframeOcuparPainelCompleto) {
          this.iframeOcuparPainelCompleto = true
          return
        }
      }

      if(!MetodosGlobais.isTextoVazio(this.fonte.titulo))
        this.tituloPagina = this.$t(this.fonte.titulo)
      if(!MetodosGlobais.isTextoVazio(this.fonte.nomeFonte))
        this.rodapePagina = "Fonte: " + this.fonte.nomeFonte
      if(!MetodosGlobais.isTextoVazio(this.fonte.rodapeComplementar))
        this.rodapeComplementarPagina = this.$t(this.fonte.rodapeComplementar)
      if(!MetodosGlobais.isTextoVazio(this.fonte.conteudoTooltip))
        this.tooltipOptions = {content: this.$t(this.fonte.conteudoTooltip), placement: !MetodosGlobais.isTextoVazio(this.fonte.posicaoTooltip) ? this.fonte.posicaoTooltip : 'bottom'}
    }
  },
}
</script>

<style lang="scss">
</style>